import React, { useEffect, useState } from 'react';
import styles from './AboutMe.module.scss';
import { useTranslation } from "react-i18next";
import LanguageIcon from '@mui/icons-material/Language';
import { useLangContext } from '../../Context/LanguageContext'

export default function AboutMe() {
    const { i18n, t } = useTranslation();
    
    const { lang } = useLangContext();

    useEffect(()=>{
        i18n.changeLanguage(lang);
    },[lang])


    const name = t('name');

    const studies = [
        t('studies.softwareEngineeringStudent'),
        t('studies.webDevelopment'),
        t('studies.blockchainStudies'),
        t('studies.blockchainMiniLecture')
    ];

    const projects = [
        t('projects.personalBlogDevelopment'),
        t('projects.restApiCreation'),
        t('projects.openSourceParticipation')
    ];

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h1>{t('titleHeader')}</h1>
            </header>
            <p>{t('presentation')}</p>
            <div className={styles.content}>
                <div className={styles.text}>
                    <h3>{t('mystud')}</h3>
                    <ul>
                        {studies.map((study, index) => (
                            <li key={index}>{study}</li>
                        ))}
                    </ul>
                    <h3>{t('myproj')}</h3>
                    <ul>
                        {projects.map((project, index) => (
                            <li key={index}>{project}</li>
                        ))}
                    </ul>
                </div>
                <div className={styles.image}>
                    <img src="https://i.pinimg.com/564x/86/6c/24/866c2407ff76c5e6398392fcb7fbda47.jpg" alt="" />
                </div>
            </div>
        </div>
    );
}
